import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccessControlDomainModule } from '@p2p/access-control/domain';

import { PermissionsPipe } from './pipes/permissions.pipe';

@NgModule({
    imports: [CommonModule, AccessControlDomainModule],
    exports: [PermissionsPipe],
    declarations: [PermissionsPipe]
})
export class AccessControlUtilsModule {}
